import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { isPC } from 'constants/layout';
import React, { ReactNode } from 'react';
import { ExclamationIcon2 } from 'icons/ExclamationIcon2';

export const LoginView = ({
  title,
  description,
  Icon,
  children,
}: {
  title: string;
  description: string;
  Icon?: typeof ExclamationIcon2;
  children: ReactNode;
}) => (
  <LoginContentWrapper>
    <LoginTitleWrapper>
      <LoginTitle>{title}</LoginTitle>
      <LoginDescription>
        {Icon && <Icon />}
        <LoginDescriptionText>{description}</LoginDescriptionText>
      </LoginDescription>
    </LoginTitleWrapper>
    <LoginContentLayout>{children}</LoginContentLayout>
  </LoginContentWrapper>
);

const LoginContentWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;

  width: 100%;
  height: 100%;
  padding: 60px 24px 24px 24px;
  background-color: ${Color.White};

  @media (${isPC}) {
    flex-grow: 0;
    height: fit-content;
    min-height: 584px;
    width: 500px;
    padding: 40px;

    border: 1px solid ${Color.Gray300};
    border-radius: 16px;
  }
`;

const LoginTitleWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & p {
    font-style: normal;
    white-space: pre-line;
    text-align: center;
  }
`;

const LoginTitle = styled.p`
  color: ${Color.Black};
  font-weight: ${FontWeight.Bold};
  ${Typography.XLarge}
`;

const LoginDescription = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 8px;

  > svg {
    margin-right: 8px;
  }
`;

const LoginDescriptionText = styled.p`
  color: ${Color.Gray700};
`;

const LoginContentLayout = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  width: 100%;
  height: 100%;
  flex-grow: 1;

  > * {
    align-self: stretch;
  }
`;
